export default "__VITE_ASSET__SLheTyWz__"